<ul
  nz-menu
  nzInlineCollapsed="false"
  nzMode="inline">
  @for (item of navigationItems; track trackParent(index, item); let index = $index) {
    <li
      nz-submenu
      [attr.data-submenu-id]="index"
      [nzOpen]="openMap[index]"
      [nzPaddingLeft]="0"
      (nzOpenChange)="openHandler(index)">
      <div title>
        @if (openMap[index]) {
          <ui-icon key="chevron-down"></ui-icon>
        } @else {
          <ui-icon key="chevron-right"></ui-icon>
        }
        <span class="title">{{ item.label | uppercase }} {{ item.year }}</span>
        <span class="count">{{ item?.count ?? 0 }}</span>
      </div>
      <!-- custom collapsing / expanding is used, native was not working for our case -->
      @if (openMap[index]) {
        <ul>
          @for (child of item.children; track trackChild($index, child)) {
            @if (child.page && !child.children) {
              <li
                class="profile"
                nz-menu-item
                [nzPaddingLeft]="8"
                [nzSelected]="child.page.subpage === currentPage">
                <a
                  [queryParams]="{ profile: child.page.profile, framework: child.page.framework, year: child.page.year, subpage: child.page.subpage }"
                  [routerLink]="['./']"
                  >{{ child.label | transloco }}</a
                >
              </li>
            }
            @if (child.children) {
              <!-- if we want to have section clickable, need to by styled as nz-menu-group -->
              @if (child.page) {
                <li
                  class="as-group"
                  nz-menu-item
                  [nzPaddingLeft]="0"
                  [nzSelected]="child.page.subpage === currentPage">
                  <a
                    [queryParams]="{ profile: child.page.profile, framework: child.page.framework, year: child.page.year, subpage: child.page.subpage }"
                    [routerLink]="['./']"
                    >{{ child.label | transloco }}</a
                  >
                </li>
              } @else {
                <li
                  nz-menu-group
                  [nzTitle]="child.label | transloco"></li>
              }
              @for (child of child.children; track child.label) {
                <li
                  nz-menu-item
                  [nzPaddingLeft]="8"
                  [nzSelected]="child.page?.subpage === currentPage">
                  <a
                    [queryParams]="{ profile: child.page?.profile, framework: child.page?.framework, year: child.page?.year, subpage: child.page?.subpage }"
                    [routerLink]="['./']"
                    >{{ child.label }}</a
                  >
                </li>
              }
            }
          }
        </ul>
      }
    </li>
  }
</ul>
